import Component from '../abstracts/Component';

export default class PdpGalleryComponent extends Component {
  get SELECTORS() {
    return {
      thumbs: '[data-gallery-thumb]',
      slideVisible: '[data-gallery-main-img].on-view',
      slider: '[data-gallery-slider]',
      images: '[data-gallery-main-img]',
      gallery: '[data-gallery]',
      galleryCloseBtn: '[data-gallery-close]',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
    };
  }

  get CLASSNAMES() {
    return {
      slideVisible: 'on-view',
      galleryShow: 'show',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.thumbs = this.$component.querySelectorAll(this.SELECTORS.thumbs);
    this.images = this.$component.querySelectorAll(this.SELECTORS.images);
    this.slider = this.$component.querySelector(this.SELECTORS.slider);
    this.currentSlide = this.$component.querySelector(this.SELECTORS.slideVisible);
    this.gallery = this.$component.querySelector(this.SELECTORS.gallery);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.galleryCloseBtn);
  }

  isMobile() {
    let mq = window.matchMedia('(max-width:767px)');
    let isMobile = mq.matches;
    return isMobile;
  }

  thumbsHandler() {
    for (let thumb of this.thumbs) {
      thumb.addEventListener('click', () => {
        let targetId = thumb.dataset.targetImgId;
        this.currentSlide.classList.remove(this.CLASSNAMES.slideVisible);
        this.currentSlide = document.getElementById(targetId);
        this.currentSlide.classList.add(this.CLASSNAMES.slideVisible);
      });
    }
  }

  sliderHandler() {
    let mq = window.matchMedia('(max-width:767px)');
    this.mobileSlider(this.slider);
    mq.addListener(e => {
      if (e.matches) {
        this.mobileSlider(this.slider);
      } else {
        $(this.slider).slick('unslick');
      }
    });
  }

  mobileSlider(slider) {
    let prevLabel = slider?.dataset.prevLabel || '';
    let nextLabel = slider?.dataset.nextLabel || '';
    if (this.isMobile()) {
      $(slider).on('init', () => {
        this.animateArrows(slider);
      });
      this.moduleLoader.loadCarouselAndExecute(() => {
        $(slider).slick({
          dots: false,
          arrows: true,
          prevArrow:
            `<button type="button" class="w__slick-prev icon-slick-prev" aria-label="${prevLabel}" data-prev-arrow><i class="icon-slick-prev"></i></button>`,
          nextArrow:
            `<button type="button" class="w__slick-next icon-slick-next" aria-label="${nextLabel}" data-next-arrow><i class="icon-slick-next"></i></button>`,
          infinite: true,
          slidesToShow: 1,
          centerMode: false,
        });
      });
    }
  }

  animateArrows(slider) {
    let prevArrow = slider.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener('mousedown', () => {
        prevArrow.classList.remove('transition');
      });
      prevArrow.addEventListener('click', () => {
        prevArrow.classList.add('transition');
      });
    }
    let nextArrow = slider.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener('mousedown', () => {
        nextArrow.classList.remove('transition');
      });
      nextArrow.addEventListener('click', () => {
        nextArrow.classList.add('transition');
      });
    }
  }

  galleryHandler() {
    let scrollY;
    if (this.images.length) {
      this.images.forEach(image => {
        image.addEventListener('click', () => {
          let imgId = image.id;
          let targetImg = this.$component.querySelector(`[data-gallery-img="${imgId}"]`);
          this.gallery.classList.add(this.CLASSNAMES.galleryShow);
          targetImg.scrollIntoView();
          scrollY = window.scrollY;
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
        });
      });
    }
    this.closeBtn.addEventListener('click', () => {
      this.gallery.classList.remove(this.CLASSNAMES.galleryShow);
      document.body.style.position = '';
      window.scrollTo(0, scrollY);
    });
  }

  render() {
    this.log('Rendering...');
    this.thumbsHandler();
    this.sliderHandler();
    this.galleryHandler();
  }
}
